// import React, { useState, useRef } from 'react';
// import emailjs from '@emailjs/browser';

// // ContactForm Component with EmailJS Integration
// const ContactForm = () => {
//   const formRef = useRef();
//   const [isLoading, setIsLoading] = useState(false);
//   const [isSuccess, setIsSuccess] = useState(false);
//   const [error, setError] = useState('');
  
//   // Form state
//   const [formData, setFormData] = useState({
//     firstName: '',
//     lastName: '',
//     email: '',
//     phone: '',
//     projectType: '',
//     message: ''
//   });

//   // Handle input changes
//   const handleChange = (e) => {
//     const { name, value } = e.target;
//     setFormData(prev => ({
//       ...prev,
//       [name]: value
//     }));
//   };

//   // Handle form submission
//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setIsLoading(true);
//     setError('');

//     try {
//       // EmailJS configuration - Replace with your actual credentials
//       const serviceId = 'YOUR_SERVICE_ID'; // Replace with your EmailJS service ID
//       const templateId = 'YOUR_TEMPLATE_ID'; // Replace with your EmailJS template ID
//       const publicKey = 'YOUR_PUBLIC_KEY'; // Replace with your EmailJS public key

//       // For demo purposes, we'll simulate the email sending
//       // In real implementation, uncomment the EmailJS code below:
      
//       // const result = await emailjs.sendForm(
//       //   serviceId,
//       //   templateId,
//       //   formRef.current,
//       //   publicKey
//       // );

//       // Simulate API call for demo
//       await new Promise(resolve => setTimeout(resolve, 2000));
      
//       // Simulate success
//       setIsSuccess(true);
//       // Reset form
//       setFormData({
//         firstName: '',
//         lastName: '',
//         email: '',
//         phone: '',
//         projectType: '',
//         message: ''
//       });
      
//       // Hide success message after 5 seconds
//       setTimeout(() => setIsSuccess(false), 5000);

//     } catch (error) {
//       console.error('Email sending error:', error);
//       setError('Failed to send message. Please try again or contact us directly.');
//     } finally {
//       setIsLoading(false);
//     }
//   };

//   return (
//     <div className="bg-gradient-to-br from-white to-gray-50 p-8 lg:p-10 rounded-3xl shadow-xl border border-gray-100 hover:shadow-2xl transition-all duration-300">
//       <h3 className="text-2xl font-bold text-gray-900 mb-8">Send us a message</h3>
      
//       {/* Success Message */}
//       {isSuccess && (
//         <div className="mb-6 p-4 bg-green-50 border border-green-200 rounded-xl">
//           <div className="flex items-center">
//             <span className="text-green-600 text-xl mr-3">✅</span>
//             <p className="text-green-700 font-semibold">
//               Message sent successfully! We'll get back to you soon.
//             </p>
//           </div>
//         </div>
//       )}

//       {/* Error Message */}
//       {error && (
//         <div className="mb-6 p-4 bg-red-50 border border-red-200 rounded-xl">
//           <div className="flex items-center">
//             <span className="text-red-600 text-xl mr-3">❌</span>
//             <p className="text-red-700 font-semibold">{error}</p>
//           </div>
//         </div>
//       )}
      
//       <div ref={formRef} className="space-y-6">
//         <div className="grid md:grid-cols-2 gap-6">
//           <div>
//             <label className="block text-gray-700 font-semibold mb-2">First Name</label>
//             <input 
//               type="text" 
//               name="firstName"
//               value={formData.firstName}
//               onChange={handleChange}
//               required
//               className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-violet-500 focus:ring-2 focus:ring-violet-200 transition-all duration-300 bg-white"
//               placeholder=""
//               disabled={isLoading}
//             />
//           </div>
//           <div>
//             <label className="block text-gray-700 font-semibold mb-2">Last Name</label>
//             <input 
//               type="text" 
//               name="lastName"
//               value={formData.lastName}
//               onChange={handleChange}
//               required
//               className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-violet-500 focus:ring-2 focus:ring-violet-200 transition-all duration-300 bg-white"
//               placeholder=""
//               disabled={isLoading}
//             />
//           </div>
//         </div>
        
//         <div>
//           <label className="block text-gray-700 font-semibold mb-2">Email Address</label>
//           <input 
//             type="email" 
//             name="email"
//             value={formData.email}
//             onChange={handleChange}
//             required
//             className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-violet-500 focus:ring-2 focus:ring-violet-200 transition-all duration-300 bg-white"
//             placeholder="name@example.com"
//             disabled={isLoading}
//           />
//         </div>
        
//         <div>
//           <label className="block text-gray-700 font-semibold mb-2">Phone Number</label>
//           <input 
//             type="tel" 
//             name="phone"
//             value={formData.phone}
//             onChange={handleChange}
//             className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-violet-500 focus:ring-2 focus:ring-violet-200 transition-all duration-300 bg-white"
//             placeholder="+91 "
//             disabled={isLoading}
//           />
//         </div>
        
//         <div>
//           <label className="block text-gray-700 font-semibold mb-2">Project Type</label>
//           <select 
//             name="projectType"
//             value={formData.projectType}
//             onChange={handleChange}
//             required
//             className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-violet-500 focus:ring-2 focus:ring-violet-200 transition-all duration-300 bg-white"
//             disabled={isLoading}
//           >
//             <option value="">Select a service</option>
//             <option value="Web Development">Web Development</option>
//             <option value="Mobile App">Mobile App</option>
//             <option value="Brand Identity">Brand Identity</option>
//             <option value="UI/UX Design">UI/UX Design</option>
//             <option value="Graphic design">Graphic design</option>
//             <option value="Digital marketing">Digital marketing</option>
//             <option value="Other">Other</option>
//           </select>
//         </div>
        
//         <div>
//           <label className="block text-gray-700 font-semibold mb-2">Message</label>
//           <textarea 
//             rows={5}
//             name="message"
//             value={formData.message}
//             onChange={handleChange}
//             required
//             className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:border-violet-500 focus:ring-2 focus:ring-violet-200 transition-all duration-300 bg-white resize-none"
//             placeholder="Tell us about your project..."
//             disabled={isLoading}
//           />
//         </div>
        
//         <button 
//           onClick={handleSubmit}
//           disabled={isLoading}
//           className={`w-full px-8 py-4 rounded-xl font-bold text-lg transition-all duration-300 ${
//             isLoading 
//               ? 'bg-gray-400 cursor-not-allowed' 
//               : 'bg-gradient-to-r from-violet-500 to-emerald-500 hover:shadow-2xl transform hover:scale-105 hover:-translate-y-1'
//           } text-white`}
//         >
//           {isLoading ? (
//             <div className="flex items-center justify-center">
//               <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-white mr-3"></div>
//               Sending...
//             </div>
//           ) : (
//             'Send Message'
//           )}
//         </button>
//       </div>
//     </div>
//   );
// };

// // Main Contact Section Component
// const ContactSection = () => {
//   return (
//     <section id="contact" className="py-20 bg-white relative overflow-hidden">
//       {/* Background Elements */}
//       <div className="absolute inset-0">
//         <div className="absolute top-10 right-10 w-80 h-80 bg-gradient-to-r from-emerald-200 to-teal-200 rounded-full mix-blend-multiply filter blur-3xl opacity-50 animate-pulse"></div>
//         <div className="absolute bottom-10 left-10 w-96 h-96 bg-gradient-to-r from-violet-200 to-purple-200 rounded-full mix-blend-multiply filter blur-3xl opacity-50 animate-pulse" style={{ animationDelay: '1s' }}></div>
        
//         {/* Floating Elements */}
//         <div className="absolute top-1/4 left-1/4 w-6 h-6 bg-gradient-to-r from-violet-400 to-indigo-400 rounded-full animate-bounce opacity-30" style={{ animationDelay: '0.5s' }}></div>
//         <div className="absolute top-3/4 right-1/4 w-4 h-4 bg-gradient-to-r from-emerald-400 to-teal-400 transform rotate-45 animate-pulse opacity-30" style={{ animationDelay: '1.5s' }}></div>
//       </div>

//       <div className="relative z-10 max-w-7xl mx-auto px-6">
//         <div className="text-center mb-16">
//           <div className="inline-flex items-center px-6 py-3 bg-gradient-to-r from-violet-50 to-emerald-50 border border-violet-200 rounded-full mb-8 shadow-lg">
//             <span className="text-violet-700 text-sm font-semibold">💬 Let's Start Something Amazing</span>
//           </div>
          
//           <h2 className="text-4xl lg:text-5xl font-bold text-gray-900 mb-6">
//             Get In
//             <span className="block bg-gradient-to-r from-violet-600 to-emerald-600 bg-clip-text text-transparent">
//               Touch
//             </span>
//           </h2>
//           <p className="text-xl text-gray-600 max-w-3xl mx-auto leading-relaxed">
//             Ready to transform your digital presence? Let's discuss your project and create something extraordinary together.
//           </p>
//         </div>

//         <div className="grid lg:grid-cols-2 gap-12 items-start">
//           {/* Contact Form with EmailJS */}
//           <ContactForm />

//           {/* Contact Information */}
//           <div className="space-y-8">
//             <div className="bg-gradient-to-br from-violet-50 to-indigo-50 p-8 rounded-3xl border border-violet-100 hover:shadow-xl transition-all duration-300 transform hover:scale-105">
//               <div className="w-16 h-16 bg-gradient-to-r from-violet-500 to-indigo-500 rounded-2xl flex items-center justify-center mb-6 animate-pulse">
//                 <span className="text-white text-2xl">📧</span>
//               </div>
//               <h3 className="text-xl font-bold text-gray-900 mb-3">Email Us</h3>
//               <p className="text-gray-600 mb-2">Ready to start your project?</p>
//               <a href="mailto:contact@kanactify.in" className="text-violet-600 font-semibold hover:text-violet-700 transition-colors">
//                 contact@kanactify.in
//               </a>
//             </div>

//             <div className="bg-gradient-to-br from-emerald-50 to-teal-50 p-8 rounded-3xl border border-emerald-100 hover:shadow-xl transition-all duration-300 transform hover:scale-105">
//               <div className="w-16 h-16 bg-gradient-to-r from-emerald-500 to-teal-500 rounded-2xl flex items-center justify-center mb-6 animate-pulse" style={{ animationDelay: '0.5s' }}>
//                 <span className="text-white text-2xl">📞</span>
//               </div>
//               <h3 className="text-xl font-bold text-gray-900 mb-3">Call Us</h3>
//               <p className="text-gray-600 mb-2">Let's discuss your vision</p>
//               <a href="tel:+919021076873" className="text-emerald-600 font-semibold hover:text-emerald-700 transition-colors">
//                 +919021076873
//               </a>
//             </div>

//             <div className="bg-gradient-to-br from-indigo-50 to-purple-50 p-8 rounded-3xl border border-indigo-100 hover:shadow-xl transition-all duration-300 transform hover:scale-105">
//               <div className="w-16 h-16 bg-gradient-to-r from-indigo-500 to-purple-500 rounded-2xl flex items-center justify-center mb-6 animate-pulse" style={{ animationDelay: '1s' }}>
//                 <span className="text-white text-2xl">📍</span>
//               </div>
//               <h3 className="text-xl font-bold text-gray-900 mb-3">Visit Us</h3>
//               <p className="text-indigo-600 font-semibold">
//                 333 sk mahathi, mathrusreenagar,<br />
//                 miyapur, Hyd-500049
//               </p>
//             </div>

//             <div className="bg-gradient-to-br from-pink-50 to-rose-50 p-8 rounded-3xl border border-pink-100 hover:shadow-xl transition-all duration-300 transform hover:scale-105">
//               <div className="w-16 h-16 bg-gradient-to-r from-pink-500 to-rose-500 rounded-2xl flex items-center justify-center mb-6 animate-pulse" style={{ animationDelay: '1.5s' }}>
//                 <span className="text-white text-2xl">🌐</span>
//               </div>
//               <h3 className="text-xl font-bold text-gray-900 mb-3">Follow Us</h3>
//               <p className="text-gray-600 mb-4">Stay connected</p>
//               <div className="flex space-x-4">
//                 {/* Facebook */}
//                 <a 
//   href="https://www.facebook.com/share/1AXmdPDR7c/?mibextid=wwXIfr"
//   target="_blank" 
//   rel="noopener noreferrer"
// >
//   <button className="w-10 h-10 bg-white rounded-lg shadow-md hover:shadow-lg transition-all transform hover:scale-110 flex items-center justify-center">
//     <svg className="w-5 h-5 text-violet-600" fill="currentColor" viewBox="0 0 24 24">
//       <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
//     </svg>
//   </button>
// </a>

                
//                 {/* Twitter */}
//                                {/* <a 
//   href="https://www.facebook.com/share/1AXmdPDR7c/?mibextid=wwXIfr"
//   target="_blank" 
//   rel="noopener noreferrer"
// > <button className="w-10 h-10 bg-white rounded-lg shadow-md hover:shadow-lg transition-all transform hover:scale-110 flex items-center justify-center">
//                   <svg className="w-5 h-5 text-violet-600" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M23.953 4.57a10 10 0 01-2.825.775 4.958 4.958 0 002.163-2.723c-.951.555-2.005.959-3.127 1.184a4.92 4.92 0 00-8.384 4.482C7.69 8.095 4.067 6.13 1.64 3.162a4.822 4.822 0 00-.666 2.475c0 1.71.87 3.213 2.188 4.096a4.904 4.904 0 01-2.228-.616v.06a4.923 4.923 0 003.946 4.827 4.996 4.996 0 01-2.212.085 4.936 4.936 0 004.604 3.417 9.867 9.867 0 01-6.102 2.105c-.39 0-.779-.023-1.17-.067a13.995 13.995 0 007.557 2.209c9.053 0 13.998-7.496 13.998-13.985 0-.21 0-.42-.015-.63A9.935 9.935 0 0024 4.59z"/>
//                   </svg>
//                 </button></a> */}

//                 <a 
//   href="https://youtube.com/@kanactify?si=vDpgpPRIJiRaDq23" 
//   target="_blank" 
//   rel="noopener noreferrer"
// >
//   <button className="w-10 h-10 bg-white rounded-lg shadow-md hover:shadow-lg transition-all transform hover:scale-110 flex items-center justify-center">
//     <svg className="w-5 h-5 text-red-600" fill="currentColor" viewBox="0 0 24 24">
//       <path d="M19.615 3.184C21.27 3.623 22.5 5.003 22.5 6.801v10.397c0 1.798-1.23 3.178-2.885 3.617-2.481.624-8.614.624-8.614.624s-6.133 0-8.614-.624C1.73 20.376.5 18.996.5 17.198V6.801C.5 5.003 1.73 3.623 3.385 3.184 5.867 2.56 12 2.56 12 2.56s6.133 0 8.615.624zM9.75 8.71v6.58l5.75-3.29-5.75-3.29z"/>
//     </svg>
//   </button>
// </a>

               
                
//                 {/* LinkedIn */}
//                                                <a 
//   href="https://www.facebook.com/share/1AXmdPDR7c/?mibextid=wwXIfr"
//   target="_blank" 
//   rel="noopener noreferrer"
// > <button className="w-10 h-10 bg-white rounded-lg shadow-md hover:shadow-lg transition-all transform hover:scale-110 flex items-center justify-center">
//                   <svg className="w-5 h-5 text-violet-600" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>
//                   </svg>
//                 </button></a>
               
                
//                 {/* Instagram */}
//                                                                <a 
//   href="https://www.instagram.com/kanactify?igsh=MTcydGt2bDhuN2RkeQ%3D%3D&utm_source=qr"
//   target="_blank" 
//   rel="noopener noreferrer"
// > <button className="w-10 h-10 bg-white rounded-lg shadow-md hover:shadow-lg transition-all transform hover:scale-110 flex items-center justify-center">
//                   <svg className="w-5 h-5 text-violet-600" fill="currentColor" viewBox="0 0 24 24">
//                     <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>
//                   </svg>
//                 </button></a>
               
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

// export default ContactSection;

import React, { useState, useRef } from "react";
import emailjs from "@emailjs/browser";

/* ─── REVEAL HELPER ─── */
const RC = ({ children, delay = 0, style = {} }) => {
  const ref = useRef();
  const [on, setOn] = React.useState(false);
  React.useEffect(() => {
    const el = ref.current;
    const o = new IntersectionObserver(
      es => { es.forEach(e => { if (e.isIntersecting) { setTimeout(() => setOn(true), delay); o.unobserve(el); } }); },
      { threshold: 0.1 }
    );
    if (el) o.observe(el);
    return () => { if (el) o.unobserve(el); };
  }, [delay]);
  return (
    <div ref={ref} style={{ transition: "opacity 900ms cubic-bezier(0.4,0,0.2,1), transform 900ms cubic-bezier(0.4,0,0.2,1)", opacity: on ? 1 : 0, transform: on ? "translateY(0)" : "translateY(56px)", ...style }}>
      {children}
    </div>
  );
};

/* ─── CSS ─── */
const CSS = `
@import url('https://fonts.googleapis.com/css2?family=Playfair+Display:ital,wght@0,700;0,900;1,700&family=DM+Sans:wght@400;500;600;700&display=swap');
.ct-sec{
  padding:120px 44px;
  background:linear-gradient(160deg,#FDF8F4 0%,#FFF4EC 50%,#FDF8F4 100%);
  position:relative;overflow:hidden;
  font-family:"DM Sans",sans-serif;
}
.ct-sec *{box-sizing:border-box}
/* BG ORBS */
.ct-orb1{position:absolute;top:-120px;right:-120px;width:500px;height:500px;border-radius:50%;background:radial-gradient(circle,rgba(248,108,61,.12),transparent 70%);pointer-events:none;animation:ctob 7s ease-in-out infinite}
.ct-orb2{position:absolute;bottom:-80px;left:-80px;width:400px;height:400px;border-radius:50%;background:radial-gradient(circle,rgba(217,87,46,.08),transparent 70%);pointer-events:none;animation:ctob 9s ease-in-out infinite reverse}
.ct-grid{position:absolute;inset:0;background-image:linear-gradient(rgba(248,108,61,.03) 1px,transparent 1px),linear-gradient(90deg,rgba(248,108,61,.03) 1px,transparent 1px);background-size:48px 48px;pointer-events:none}
@keyframes ctob{0%,100%{transform:scale(1)}50%{transform:scale(1.08)}}
/* HEADER */
.ct-in{position:relative;z-index:1;max-width:1280px;margin:0 auto}
.ct-hd{text-align:center;margin-bottom:80px}
.ct-tag{display:inline-flex;align-items:center;gap:7px;background:rgba(248,108,61,.08);color:#D9572E;border:1px solid rgba(248,108,61,.22);border-radius:100px;padding:7px 20px;font-size:11px;font-weight:700;letter-spacing:2px;text-transform:uppercase;margin-bottom:20px}
.ct-tag-dot{width:6px;height:6px;background:#F86C3D;border-radius:50%;animation:ctdot 2s infinite}
@keyframes ctdot{0%,100%{box-shadow:0 0 0 0 rgba(248,108,61,.4)}50%{box-shadow:0 0 0 8px transparent}}
.ct-hd h2{font-family:"Playfair Display",Georgia,serif;font-size:clamp(36px,5vw,60px);font-weight:900;line-height:1.08;color:#0A0A0A;margin-bottom:16px}
.ct-hd p{font-size:17px;color:#705848;line-height:1.8;max-width:560px;margin:0 auto}
/* GRID */
.ct-body{display:grid;grid-template-columns:1fr 1fr;gap:48px;align-items:start}
/* FORM CARD */
.ct-form-wrap{background:#fff;border:1px solid rgba(248,108,61,.12);border-radius:28px;padding:48px 44px;box-shadow:0 24px 72px rgba(248,108,61,.08),0 4px 24px rgba(0,0,0,.04);position:relative;overflow:hidden}
.ct-form-wrap::before{content:"";position:absolute;top:0;left:0;right:0;height:3px;background:linear-gradient(90deg,#F86C3D,#FF8A5C,#F86C3D);background-size:200% 100%;animation:ctbar 3s linear infinite}
@keyframes ctbar{0%{background-position:0% 0%}100%{background-position:200% 0%}}
.ct-form-wrap h3{font-family:"Playfair Display",serif;font-size:26px;font-weight:700;color:#0A0A0A;margin-bottom:32px}
/* ROW */
.ct-row{display:grid;grid-template-columns:1fr 1fr;gap:18px}
/* FIELD */
.ct-field{margin-bottom:20px}
.ct-field label{display:block;font-size:12px;font-weight:700;letter-spacing:.8px;text-transform:uppercase;color:#705848;margin-bottom:8px}
.ct-field input,.ct-field select,.ct-field textarea{
  width:100%;padding:13px 18px;
  border:1.5px solid rgba(248,108,61,.15);
  border-radius:14px;
  font-family:"DM Sans",sans-serif;
  font-size:14px;
  color:#0A0A0A;
  background:#FFFCF9;
  outline:none;
  transition:border-color .25s,box-shadow .25s,background .25s;
  resize:none;
}
.ct-field input::placeholder,.ct-field textarea::placeholder{color:#B09080}
.ct-field input:focus,.ct-field select:focus,.ct-field textarea:focus{
  border-color:#F86C3D;
  box-shadow:0 0 0 4px rgba(248,108,61,.1);
  background:#fff;
}
.ct-field select{cursor:pointer;appearance:none;background-image:url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='12' height='8' viewBox='0 0 12 8'%3E%3Cpath fill='%23F86C3D' d='M1 1l5 5 5-5'/%3E%3C/svg%3E");background-repeat:no-repeat;background-position:right 16px center}
/* SUBMIT BTN */
.ct-btn{
  width:100%;padding:16px;border-radius:14px;
  background:linear-gradient(135deg,#F86C3D,#D9572E);
  color:#fff;font-family:"DM Sans",sans-serif;
  font-size:15px;font-weight:700;border:none;cursor:pointer;
  box-shadow:0 8px 28px rgba(248,108,61,.35);
  transition:transform .25s cubic-bezier(.34,1.56,.64,1),box-shadow .25s;
  display:flex;align-items:center;justify-content:center;gap:10px;
}
.ct-btn:hover{transform:translateY(-3px);box-shadow:0 16px 44px rgba(248,108,61,.45)}
.ct-btn:disabled{background:#ccc;box-shadow:none;transform:none;cursor:not-allowed}
.ct-btn-spin{width:20px;height:20px;border:2.5px solid rgba(255,255,255,.3);border-top-color:#fff;border-radius:50%;animation:ctspin .8s linear infinite}
@keyframes ctspin{to{transform:rotate(360deg)}}
/* ALERTS */
.ct-ok{margin-bottom:24px;padding:14px 18px;background:rgba(34,197,94,.08);border:1px solid rgba(34,197,94,.25);border-radius:14px;display:flex;align-items:center;gap:10px;font-size:14px;font-weight:600;color:#166534}
.ct-err{margin-bottom:24px;padding:14px 18px;background:rgba(239,68,68,.07);border:1px solid rgba(239,68,68,.22);border-radius:14px;display:flex;align-items:center;gap:10px;font-size:14px;font-weight:600;color:#991b1b}
/* INFO SIDE */
.ct-info{display:flex;flex-direction:column;gap:20px}
.ct-info-card{
  background:#fff;border:1px solid rgba(248,108,61,.1);
  border-radius:22px;padding:28px 28px;
  box-shadow:0 4px 24px rgba(248,108,61,.06);
  display:flex;gap:20px;align-items:flex-start;
  transition:border-color .3s,box-shadow .35s,transform .35s cubic-bezier(.34,1.56,.64,1);
}
.ct-info-card:hover{border-color:rgba(248,108,61,.35);box-shadow:0 12px 40px rgba(248,108,61,.12);transform:translateY(-4px)}
.ct-info-icon{
  width:52px;height:52px;border-radius:14px;flex-shrink:0;
  background:linear-gradient(135deg,#F86C3D,#D9572E);
  display:flex;align-items:center;justify-content:center;
  font-size:22px;box-shadow:0 6px 20px rgba(248,108,61,.3);
}
.ct-info-title{font-family:"Playfair Display",serif;font-size:16px;font-weight:700;color:#0A0A0A;margin-bottom:4px}
.ct-info-sub{font-size:12px;color:#9A8070;font-weight:500;margin-bottom:6px}
.ct-info-val{font-size:14px;font-weight:700;color:#D9572E}
.ct-info-val a{color:#D9572E;text-decoration:none;transition:color .2s}
.ct-info-val a:hover{color:#F86C3D}
/* SOCIAL ROW */
.ct-socials{display:flex;gap:10px;flex-wrap:wrap}
.ct-soc{
  width:40px;height:40px;border-radius:10px;
  background:#FDF8F4;border:1.5px solid rgba(248,108,61,.15);
  display:flex;align-items:center;justify-content:center;
  transition:all .25s cubic-bezier(.34,1.56,.64,1);cursor:pointer;
}
.ct-soc:hover{background:linear-gradient(135deg,#F86C3D,#D9572E);border-color:transparent;transform:scale(1.14)}
.ct-soc:hover svg{fill:#fff}
.ct-soc svg{width:18px;height:18px;fill:#D9572E;transition:fill .2s}
/* RESPONSIVE */
@media(max-width:900px){.ct-body{grid-template-columns:1fr}.ct-sec{padding:80px 24px}}
@media(max-width:480px){.ct-row{grid-template-columns:1fr}.ct-form-wrap{padding:32px 24px}}
`;

const ContactSection = () => {
  const formRef = useRef();
  const [loading, setLoading] = useState(false);
  const [ok, setOk] = useState(false);
  const [err, setErr] = useState("");
  const [form, setForm] = useState({ firstName:"", lastName:"", email:"", phone:"", projectType:"", message:"" });

  const ch = e => { const {name,value} = e.target; setForm(p => ({...p,[name]:value})); };

  const submit = async e => {
    e.preventDefault(); setLoading(true); setErr("");
    try {
      // Replace with your actual EmailJS credentials
      // await emailjs.sendForm("YOUR_SERVICE_ID","YOUR_TEMPLATE_ID",formRef.current,"YOUR_PUBLIC_KEY");
      await new Promise(r => setTimeout(r, 1800));
      setOk(true);
      setForm({ firstName:"", lastName:"", email:"", phone:"", projectType:"", message:"" });
      setTimeout(() => setOk(false), 5000);
    } catch(e) {
      setErr("Failed to send. Please try again or call us directly.");
    } finally { setLoading(false); }
  };

  return (
    <>
      <style>{CSS}</style>
      <section id="contact" className="ct-sec">
        <div className="ct-orb1"/><div className="ct-orb2"/><div className="ct-grid"/>
        <div className="ct-in">
          <RC><div className="ct-hd">
            <div className="ct-tag"><span className="ct-tag-dot"/>Let's Talk</div>
            <h2>Get In <span style={{background:"linear-gradient(135deg,#F86C3D,#FF8A5C)",WebkitBackgroundClip:"text",WebkitTextFillColor:"transparent",backgroundClip:"text"}}>Touch</span></h2>
            <p>Ready to transform your digital presence? Let's discuss your project and turn your brand into a lead generation machine.</p>
          </div></RC>

          <div className="ct-body">
            {/* FORM */}
            <RC delay={100}>
              <div className="ct-form-wrap">
                <h3>Send Us a Message</h3>
                {ok && <div className="ct-ok"><span>✅</span> Message sent! We'll get back to you soon.</div>}
                {err && <div className="ct-err"><span>❌</span> {err}</div>}
                <div ref={formRef}>
                  <div className="ct-row">
                    <div className="ct-field"><label>First Name</label><input type="text" name="firstName" value={form.firstName} onChange={ch} required disabled={loading} placeholder="John"/></div>
                    <div className="ct-field"><label>Last Name</label><input type="text" name="lastName" value={form.lastName} onChange={ch} required disabled={loading} placeholder="Doe"/></div>
                  </div>
                  <div className="ct-field"><label>Email Address</label><input type="email" name="email" value={form.email} onChange={ch} required disabled={loading} placeholder="name@example.com"/></div>
                  <div className="ct-field"><label>Phone Number</label><input type="tel" name="phone" value={form.phone} onChange={ch} disabled={loading} placeholder="+91 98765 43210"/></div>
                  <div className="ct-field"><label>Service Interested In</label>
                    <select name="projectType" value={form.projectType} onChange={ch} required disabled={loading}>
                      <option value="">Select a service</option>
                      <option value="Social Media Marketing">Social Media Marketing</option>
                      <option value="Lead Generation">Lead Generation Campaigns</option>
                      <option value="Google Ads">Google Ads</option>
                      <option value="Meta Ads">Meta Ads (Facebook/Instagram)</option>
                      <option value="Corporate Branding">Corporate Branding</option>
                      <option value="Web Design">Web Design</option>
                      <option value="Graphic Design">Graphic Design</option>
                      <option value="SEO">Search Engine Optimization</option>
                      <option value="Other">Other</option>
                    </select>
                  </div>
                  <div className="ct-field"><label>Message</label><textarea rows={5} name="message" value={form.message} onChange={ch} required disabled={loading} placeholder="Tell us about your business and what you want to achieve..."/></div>
                  <button className="ct-btn" onClick={submit} disabled={loading}>
                    {loading ? <><div className="ct-btn-spin"/>Sending...</> : <>Send Message <span>→</span></>}
                  </button>
                </div>
              </div>
            </RC>

            {/* INFO */}
            <div className="ct-info">
              {[
                { icon:"📧", title:"Email Us", sub:"Drop us a line anytime", val:<a href="mailto:contact@kanactify.in">contact@kanactify.in</a> },
                { icon:"📞", title:"Call Us", sub:"Mon–Sat, 9am – 7pm", val:<a href="tel:+919021076873">+91 9021076873</a> },
                { icon:"📍", title:"Visit Us", sub:"Come say hello", val:"333 SK Mahathi, Mathrusreenagar, Miyapur, Hyd-500049" },
                { icon:"⏰", title:"Working Hours", sub:"We're available", val:"Mon–Sat: 9:00 AM – 7:00 PM IST" },
              ].map((c,i) => (
                <RC key={i} delay={150+i*80}>
                  <div className="ct-info-card">
                    <div className="ct-info-icon">{c.icon}</div>
                    <div>
                      <div className="ct-info-title">{c.title}</div>
                      <div className="ct-info-sub">{c.sub}</div>
                      <div className="ct-info-val">{c.val}</div>
                    </div>
                  </div>
                </RC>
              ))}
              <RC delay={550}>
                <div className="ct-info-card" style={{flexDirection:"column",gap:"16px"}}>
                  <div style={{fontFamily:"'Playfair Display',serif",fontSize:"16px",fontWeight:700,color:"#0A0A0A"}}>Follow Us</div>
                  <div className="ct-socials">
                    {[
                      {href:"https://www.facebook.com/share/1AXmdPDR7c/?mibextid=wwXIfr",icon:<path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>},
                      {href:"https://www.instagram.com/kanactify?igsh=MTcydGt2bDhuN2RkeQ%3D%3D&utm_source=qr",icon:<path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"/>},
                      {href:"https://youtube.com/@kanactify?si=vDpgpPRIJiRaDq23",icon:<path d="M19.615 3.184C21.27 3.623 22.5 5.003 22.5 6.801v10.397c0 1.798-1.23 3.178-2.885 3.617-2.481.624-8.614.624-8.614.624s-6.133 0-8.614-.624C1.73 20.376.5 18.996.5 17.198V6.801C.5 5.003 1.73 3.623 3.385 3.184 5.867 2.56 12 2.56 12 2.56s6.133 0 8.615.624zM9.75 8.71v6.58l5.75-3.29-5.75-3.29z"/>},
                      {href:"https://www.facebook.com/share/1AXmdPDR7c/?mibextid=wwXIfr",icon:<path d="M20.447 20.452h-3.554v-5.569c0-1.328-.027-3.037-1.852-3.037-1.853 0-2.136 1.445-2.136 2.939v5.667H9.351V9h3.414v1.561h.046c.477-.9 1.637-1.85 3.37-1.85 3.601 0 4.267 2.37 4.267 5.455v6.286zM5.337 7.433c-1.144 0-2.063-.926-2.063-2.065 0-1.138.92-2.063 2.063-2.063 1.14 0 2.064.925 2.064 2.063 0 1.139-.925 2.065-2.064 2.065zm1.782 13.019H3.555V9h3.564v11.452zM22.225 0H1.771C.792 0 0 .774 0 1.729v20.542C0 23.227.792 24 1.771 24h20.451C23.2 24 24 23.227 24 22.271V1.729C24 .774 23.2 0 22.222 0h.003z"/>},
                    ].map((s,i) => (
                      <a key={i} href={s.href} target="_blank" rel="noreferrer" className="ct-soc">
                        <svg viewBox="0 0 24 24">{s.icon}</svg>
                      </a>
                    ))}
                  </div>
                </div>
              </RC>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default ContactSection;